import { Menu } from "semantic-ui-react";
import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";

export const AreaDetailTabs = () => {
  let { url } = useRouteMatch();

  return (
    <Menu secondary pointing>
      <Menu.Item as={NavLink} to={`${url}/funcionarios`}>
        Funcionários
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/historico`}>
        Histórico
      </Menu.Item>
    </Menu>
  );
};
